/*
Copyright (C) Anheuser-Busch InBev SA/NV. ALL RIGHTS RESERVED.

This software product is a proprietary product of Anheuser-Busch Inbev SA/NV (the "Company") and all right, title, and interest in and to the software product, including all associated intellectual property rights, are and shall remain exclusively with the Company. All rights in or to the software product are licensed, not sold. All rights not licensed are reserved.

This software product is governed by the End User License Agreement provided with the software product.

*/
//#region src/shared.ts
var e = {
	"en-US": { translation: {
		common: {
			actions: {
				acknowledge: "Acknowledge",
				apply: "Apply",
				backFillData: "Backfill Data",
				cancel: "Cancel",
				close: "Close",
				continue: "Continue",
				delete: "Delete",
				discard: "Discard",
				discardChanges: "Discard Changes",
				edit: "Edit",
				export: "Export",
				goBack: "Go Back",
				help: "Help",
				mainMenu: "Main Menu",
				ok: "OK",
				openInNewWindow: "Open in New Window",
				optional: "Optional",
				print: "Print",
				refresh: "Refresh",
				save: "Save",
				saveChanges: "Save Changes",
				search: "Search",
				searchEllipsis: "Search...",
				selectAnOption: "Select an option",
				submit: "Submit",
				tryAgain: "Try Again",
				undo: "Undo",
				upload: "Upload",
				unsavedChanges: "Unsaved Changes"
			},
			inputs: {
				all: "All",
				city: "City",
				country: "Country",
				date: "Date",
				dateEnd: "Date End",
				dateStart: "Date Start",
				dateTime: "Date/Time",
				description: "Description",
				effectiveStartDate: "Effective Start Date",
				effectiveEndDate: "Effective End Date",
				endDate: "End Date",
				input: "Input",
				phoneNumber: "Phone Number",
				startDate: "Start Date",
				state: "State",
				temperature: "Temperature",
				time: "Time",
				year: "Year",
				zipCode: "Zip Code"
			},
			labels: {
				error: "Error",
				readonly: "read only",
				success: "Success",
				warning: "Warning",
				offline: "Network Offline"
			},
			chemistryTerms: {
				acetaldehyde: "Acetaldehyde",
				alcohol: "Alcohol",
				alcoholByWeight: "Alcohol (% By Weight)",
				alcoholByVolume: "Alcohol (% By Volume)",
				alphaAcid: "Alpha Acid",
				apparentExtract: "Apparent Extract",
				balling: "Balling",
				calories: "Calories",
				carbohydrates: "Carbohydrates",
				cellCount: "Cell Count",
				color: "Color",
				diacetyl: "Diacetyl",
				ibu: "IBU",
				iron: "Iron",
				pentanedione: "Pentanedione",
				ph: "pH",
				protein: "Protein",
				realFerm: "Real Degree of Fermentation",
				realExtract: "Real Extract",
				schoene: "Schoene",
				turbidity: "Turbidity"
			},
			units: {
				units: "Units",
				pounds: "Pounds",
				kg: "Kilograms",
				gallons: "Gallons",
				liters: "Liters",
				fluidOunces: "Fluid Ounces",
				milliliters: "Milliliters"
			},
			breweryTerms: {
				altBom: "Alt BOM",
				brand: "Brand",
				brewery: "Brewery",
				breweryNameOrCode: "Brewery Name or Brewery Code",
				brewline: "Brewline",
				brewside: "Brewside",
				cropYear: "Crop Year",
				fermenter: "Fermenter",
				fermenterType: "Fermenter Type",
				lotNumber: "Lot Number",
				material: "Material",
				materialImpacted: "Material Impacted",
				selectBrewery: "Select Brewery",
				recipeType: "Recipe Type",
				variety: "Variety",
				zoneOwner: "Zone Owner"
			},
			status: {
				status: "Status",
				active: "Active",
				cancelled: "Cancelled",
				inactive: "Inactive",
				received: "Received",
				shipped: "Shipped"
			},
			misc: { generalInformation: "General Information" },
			statusCode: "Status Code",
			forbiddenTitle: "You do not have permission for this action.",
			forbiddenMessage: "You do not have permissions for this action. Please check your roles and permissions in user profile.",
			agGrid: { pleaseClearFilters: "Please clear filters to add a new row" }
		},
		comments: {
			placeholder: "Click to add comment",
			unknownUser: "Unknown user",
			edited: "edited",
			submitError: "Comment failed to submit",
			editError: "Comment failed to edit",
			deleteError: "Comment failed to delete"
		},
		pageNotFound: "Page Not Found",
		unexpectedNetworkError: "Unexpected Network Error",
		networkErrorMessage: "An unexpected network error has occurred. Click below to refresh the page and try again. If this persists, please contact support.",
		runtimeExceptionMessage: "The application unexpectedly crashed. Click below to refresh the page and try again. If this persists, please contact support.",
		recoverableErrorMessage: "An unexpected network error has occurred. No changes have been saved. Click below to close this window and attempt the operation again. If this persists, please contact support.",
		returnTo: "Return to",
		returnToApps: "View All Apps",
		url: {
			home: "Home",
			apps: "Apps"
		},
		copyrightInfo: "Anheuser-Busch InBev. All Rights Reserved. Anheuser-Busch InBev Confidential. For Anheuser-Busch InBev internal use only.",
		permissions: {
			canAccessApplication: "You do not have permissions needed to access this application.",
			accessLinkMessage: "For information on getting proper access to this application, please reference the following Acadia SOP:"
		},
		userProfile: {
			errorMessage: "Unable to get user settings.",
			tryAgain: "Try Again",
			brewerySelectionSearchPlaceholder: "Brewery Name or Brewery Code",
			languageLabel: "Language",
			unitsLabel: "Units",
			imperialUnitsSelection: "Imperial",
			metricUnitsSelection: "Metric",
			myRoles: "Roles & Permissions",
			roles: "Roles",
			permissions: "Permissions",
			selfService: "If you need additional permissions, <0>Click Here</0> to be guided to the user guide.",
			navigationAndAccess: "Navigation & Access",
			standardSpecialsManagement: "Standard Specials Management",
			confidentialSpecialsAccess: "Confidential Specials Access",
			accessAndWorkflow: "Access & Workflow",
			recipeActions: "Recipe Actions",
			atYourBrewery: "At Your Brewery",
			atAllBreweries: "At All Breweries",
			viewRolesAndPermissions: "Roles & Permissions",
			viewNotificationSettings: "Notification Settings",
			breweryRole: "Brewery Role"
		},
		roles: {
			appAllAdmin: "All Admin",
			breweryUser: "Brewery User",
			hopsRecipeAdmin: "Admin",
			hopsRecipeEditor: "Recipe Editor",
			hopsRecipeViewer: "Recipe Viewer",
			zoneSupplyApprover: "Zone Supply Approver",
			zoneSupplyUser: "Zone Supply",
			breweryConfidentialUser: "Brewery Confidential User",
			sparePartsUser: "Spare Parts User",
			liveDotsConfigurationEditor: "Live Dots Configuration Editor",
			kpiCalcAdmin: "B&Q KPI Calculator Configuration Admin",
			kpiCalcEditor: "B&Q KPI Calculator Configuration Editor",
			cdcManagementViewer: "CDC Management Viewer",
			cdcManagementAdmin: "CDC Management Admin"
		},
		helpLinks: {
			reportAnIssue: "Report an Issue",
			enhancementReq: "Submit an Enhancement Request",
			userGuides: "User Guides"
		},
		rtf: {
			normal: "Normal",
			heading1: "Heading 1",
			heading2: "Heading 2",
			heading3: "Heading 3",
			bulletList: "Bullet List",
			numberedList: "Numbered List",
			checkList: "Check List",
			quote: "Quote",
			align: "Align",
			leftAlign: "Left Align",
			centerAlign: "Center Align",
			rightAlign: "Right Align",
			justifyAlign: "Justify Align",
			outdent: "Outdent",
			indent: "Indent",
			strikeThrough: "Strike Through",
			subScript: "Sub Script",
			superScript: "Super Script",
			clearFormatting: "Clear Formatting",
			insert: "Insert",
			horizontalRule: "Horizontal Rule",
			image: "Image",
			table: "Table",
			insertImage: "Insert Image",
			updateImage: "Update Image",
			edit: "Edit",
			enterCaption: "Enter a Caption",
			imageUpload: "Image Upload",
			chooseImage: "Choose Image",
			altText: "Alt Text",
			descriptiveAlternateText: "Descriptive Alternate Text",
			position: "Position",
			left: "Left",
			right: "Right",
			fullWidth: "Full Width",
			showCaption: "Show Caption",
			confirm: "Confirm",
			insertTable: "Insert Table",
			rows: "Rows",
			columns: "Columns"
		},
		authModal: {
			title: "End of Shift Warning",
			description: "Your session is about to expire in 5 minutes as the current shift is ending.",
			continue: "Continue Session",
			signOut: "Sign Out"
		}
	} },
	"fr-CA": { translation: {
		common: {
			labels: {
				offline: "Réseau hors ligne",
				warning: "Avertissement",
				error: "Erreur",
				readonly: "lecture seule",
				success: "Succès"
			},
			units: {
				gallons: "Gallons",
				liters: "Litres",
				units: "Unités",
				kg: "Kilos",
				pounds: "Livres"
			},
			chemistryTerms: {
				acetaldehyde: "Acétaldéhyde",
				alphaAcid: "Acide alpha",
				alcohol: "Alcool",
				alcoholByWeight: "Alcool (% en poids)",
				alcoholByVolume: "Alcool (% en volume)",
				balling: "Balling",
				calories: "Calories",
				color: "Couleur",
				realFerm: "Degré réel de fermentation",
				diacetyl: "Diacétyle",
				apparentExtract: "Extrait apparent",
				realExtract: "Extrait réel",
				iron: "Fer",
				carbohydrates: "Glucides",
				ibu: "IBU",
				cellCount: "Nombre de cellules",
				pentanedione: "Pentanedione",
				ph: "pH",
				protein: "Protéine",
				schoene: "Schöne",
				turbidity: "Turbidité"
			},
			status: {
				active: "Actif",
				cancelled: "Annulé",
				shipped: "Expédié",
				inactive: "Inactif",
				received: "Reçu"
			},
			actions: {
				help: "Aide",
				cancel: "Annuler",
				apply: "Appliquer",
				acknowledge: "Approuvé",
				continue: "Continuer",
				undo: "Défaire",
				saveChanges: "Enregistrer les modifications",
				tryAgain: "Essayer à nouveau",
				export: "Exporter",
				close: "Fermer",
				discardChanges: "Ignorer les modifications",
				print: "Imprimer",
				discard: "Jeter",
				mainMenu: "Menu principal",
				edit: "Modifier",
				openInNewWindow: "Nouvelle Fenêtre",
				ok: "OK",
				refresh: "Rafraîchir",
				search: "Recherche",
				goBack: "Retourner",
				save: "Sauvegarder",
				submit: "Soumettre",
				delete: "Supprimer"
			},
			inputs: {
				all: "Tous",
				year: "Année",
				zipCode: "Code postal",
				date: "Date",
				dateStart: "Date de début",
				startDate: "Date de début",
				effectiveStartDate: "Date de début effective",
				dateEnd: "Date de fin",
				endDate: "Date de fin",
				effectiveEndDate: "Date de fin d'effet",
				dateTime: "Date/Heure",
				description: "Description",
				state: "État",
				phoneNumber: "Numéro de téléphone",
				country: "Pays",
				input: "Saisir",
				temperature: "Température",
				time: "Temps",
				city: "Ville"
			},
			breweryTerms: {
				cropYear: "Année de récolte",
				brewery: "Brasserie",
				brewside: "Côté brasserie",
				fermenter: "Fermenteur",
				brewline: "Type de brasse",
				brand: "Marque",
				materialImpacted: "Matériau concerné",
				material: "Matériel",
				selectBrewery: "Sélectionnez une brasserie",
				breweryNameOrCode: "Nom de la brasserie ou code de la brasserie",
				altBom: "Nomenclature alternative",
				lotNumber: "Numéro de lot",
				zoneOwner: "Propriétaire de zone",
				fermenterType: "Type de fermenteur",
				recipeType: "Type de recette",
				variety: "Variété"
			},
			misc: { generalInformation: "Informations générales" }
		},
		roles: {
			appAllAdmin: "Tous les administrateurs",
			breweryConfidentialUser: "Utilisateur confidentiel de la brasserie",
			breweryUser: "Utilisateur de la brasserie",
			hopsRecipeAdmin: "Administrateur",
			hopsRecipeEditor: "Éditeur de recettes",
			hopsRecipeViewer: "Visualiseur de recettes",
			zoneSupplyUser: "Approvisionnement de la zone"
		},
		userProfile: {
			accessAndWorkflow: "Accès & Flux de travail",
			atAllBreweries: "Dans toutes les brasseries",
			atYourBrewery: "Dans votre brasserie",
			breweryRole: "Rôle de la brasserie",
			confidentialSpecialsAccess: "Accès aux offres spéciales confidentielles",
			myRoles: "Rôles & Permissions",
			navigationAndAccess: "Navigation & Accès",
			permissions: "Permissions",
			recipeActions: "Actions sur les recettes",
			roles: "Rôles",
			selfService: "Si vous avez besoin de permissions supplémentaires, <0>Cliquez ici</0> pour être guidé vers le guide utilisateur.",
			standardSpecialsManagement: "Gestion des offres spéciales standard",
			viewNotificationSettings: "Paramètres de Notification",
			viewRolesAndPermissions: "Rôles & Permissions",
			imperialUnitsSelection: "Impérial",
			languageLabel: "Langue",
			metricUnitsSelection: "Métrique",
			brewerySelectionSearchPlaceholder: "Nom de la Brasserie ou Code de la Brasserie",
			tryAgain: "Try Again",
			errorMessage: "Unable to get user settings.",
			unitsLabel: "Unités"
		},
		rtf: {
			showCaption: "Afficher la légende",
			align: "Alignement",
			rightAlign: "Alignement à droite",
			leftAlign: "Alignement à gauche",
			centerAlign: "Alignement au centre",
			justifyAlign: "Alignement justifié",
			indent: "Augmenter le retrait",
			strikeThrough: "Barré",
			chooseImage: "Choisir une image",
			quote: "Citation",
			columns: "Colonnes",
			confirm: "Confirmer",
			outdent: "Diminuer le retrait",
			right: "Droite",
			clearFormatting: "Effacer le formatage",
			enterCaption: "Entrer une légende",
			superScript: "Exposant",
			left: "Gauche",
			image: "Image",
			subScript: "Indice",
			insert: "Insérer",
			insertTable: "Insérer un tableau",
			insertImage: "Insérer une image",
			fullWidth: "Largeur totale",
			rows: "Lignes",
			bulletList: "Liste à puces",
			checkList: "Liste de contrôle",
			numberedList: "Liste numérotée",
			updateImage: "Mettre à jour l'image",
			edit: "Modifier",
			normal: "Normale",
			position: "Position",
			horizontalRule: "Règle horizontale",
			table: "Tableau",
			imageUpload: "Téléchargement d'image",
			altText: "Texte alternatif",
			descriptiveAlternateText: "Texte alternatif descriptif",
			heading1: "Titre 1",
			heading2: "Titre 2",
			heading3: "Titre 3"
		},
		returnToApps: "Afficher toutes les Applications",
		copyrightInfo: "Anheuser-Busch InBev. Tous droits réservés. Anheuser-Busch InBev confidentiel. Pour usage interne d’Anheuser-Busch InBev uniquement.",
		url: {
			apps: "Applications",
			home: "Maison"
		},
		authModal: {
			title: "Avertissement de fin de quart de travail",
			continue: "Continuer la session",
			signOut: "Se déconnecter",
			description: "Votre session est sur le point d'expirer dans 5 minutes alors que l'équipe en cours se termine."
		},
		unexpectedNetworkError: "Erreur Réseau Inattendue",
		helpLinks: {
			userGuides: "Guides de l'utilisateur",
			reportAnIssue: "Signaler un problème",
			enhancementReq: "Soumettre une demande d'amélioration"
		},
		runtimeExceptionMessage: "L'application s'est écrasée de manière inattendue. Cliquez ci-dessous pour actualiser la page et réessayer. Si cela persiste, veuillez contacter le support.",
		comments: {
			placeholder: "Cliquez pour ajouter un commentaire",
			unknownUser: "Utilisateur inconnu",
			edited: "édité",
			submitError: "Le commentaire n'a pas pu être soumis",
			editError: "Le commentaire n'a pas pu être modifié",
			deleteError: "Le commentaire n'a pas pu être supprimé"
		},
		pageNotFound: "Page Non Trouvée",
		permissions: {
			accessLinkMessage: "Pour obtenir des informations sur l'accès approprié à cette application, veuillez consulter la SOP d'Acadia suivante\xA0:",
			canAccessApplication: "Vous ne disposez pas des autorisations nécessaires pour accéder à cette application."
		},
		returnTo: "Retourner à",
		recoverableErrorMessage: "Une erreur réseau inattendue s'est produite. Aucune modification n'a été enregistrée. Cliquez ci-dessous pour fermer cette fenêtre et tenter à nouveau l'opération. Si cela persiste, veuillez contacter le support.",
		networkErrorMessage: "Une erreur réseau inattendue s'est produite. Cliquez ci-dessous pour actualiser la page et réessayer. Si cela persiste, veuillez contacter le support."
	} }
};
//#endregion
export { e as default };

//# sourceMappingURL=shared.js.map